import { format } from 'date-fns';
import type { Filters } from 'hooks/store/pending-stocks';
import type { FormSchema } from './formSchema';

const f = (date: Date) => {
  return format(date, 'yyyy-MM-dd');
};

export const createReportParams = ({
  formData,
  statuses,
  columns,
}: {
  formData: FormSchema;
  statuses?: string[];
  columns?: string[];
}): Record<string, unknown> => {
  const { invoiceNumber, productIds, companyIds, agDate } = formData;

  return {
    ...(invoiceNumber && { invoiceNumber }),
    ...(productIds?.length && { productIds: productIds.toString() }),
    ...(companyIds?.length && { companyIds: companyIds.toString() }),
    ...(agDate?.from && {
      agDateStart: f(agDate.from),
    }),
    ...(agDate?.to && {
      expirationDateEnd: f(agDate.to),
    }),
    ...(statuses?.length && { statuses: statuses.toString() }),
    ...(columns?.length && { columns }),
  };
};

export const createFilterParams = ({
  formData,
  statuses,
}: {
  formData: FormSchema;
  statuses?: string[];
}): Filters => {
  const { agDate, ...rest } = formData;

  return {
    ...rest,
    ...(agDate?.from && { expirationDateStart: f(agDate.from) }),
    ...(agDate?.to && { expirationDateEnd: f(agDate.to) }),
    ...(statuses?.length && { statuses }),
  };
};
